import type { FaireProductEntity } from "../../entity_types/product";

export const p_gx85dug7cv: FaireProductEntity = {
  token: "p_gx85dug7cv",
  type: "product",
  name: "Dainty Zodiac Gold Necklace-12 Pcs",
  brandToken: "b_b8csz3xa8h",
  brandName: "Gypsy Soul",
  imageUrl:
    "https://cdn.faire.com/fastly/257d98a3a5aa9c5fd83cf9d2188176371239724d77463ea444e8eabace1e0f78.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6f58faa32f498cb014fa87481993bb5be5b2de237d0b18b8dc9961922a89ed0b.jpeg",
    "https://cdn.faire.com/fastly/3f654bc5cc230257791419e7d0bf6273b13557c1691dd4eaca8af77fff5780f8.jpeg",
    "https://cdn.faire.com/fastly/899d5f8f0e505b003a5798dd8e4f081cb50abdf8845d4492a9f62cf8971b1f3e.jpeg",
    "https://cdn.faire.com/fastly/9b22af0e746cd3c54ce36b258fea461923ad5b2b623104116a616ec54c2c968c.jpeg",
    "https://cdn.faire.com/fastly/fffb9d5129a5a0119ef58315e20fa1164c291adb8a64956da96ecc7d9ba28a74.jpeg",
    "https://cdn.faire.com/fastly/b5e23ed4d41fdaf18e88a4e1c3fdad9ce6d20bc631f0cb1f5d4dc18bf389a7c3.jpeg",
    "https://cdn.faire.com/fastly/1c0e9767a5318fb7ba8f4c8e1605d5709f7d668cd0e750f14d753f80f9b83d47.jpeg",
    "https://cdn.faire.com/fastly/cad1507ae174377fc9cf5cffb7e54ea79747a65246f53fbdce7d99b4d07b0eae.jpeg",
    "https://cdn.faire.com/fastly/88ab5144ffd4743ff646bf928da3c49ea707ff9b29ceabaabc41bb58562b155d.jpeg",
    "https://cdn.faire.com/fastly/f9807269a7a5a77643248648437d3a08f0de3bdf9ae0024ab5dfd9e8fea09c00.jpeg",
    "https://cdn.faire.com/fastly/a2780adc6ef7ed3c20155944c2078dbf395efabf59e1b642e7ccdc9cd35576bf.jpeg",
    "https://cdn.faire.com/fastly/1696f399a4cc5971198268f9736427bf5c6340c8e84ad14a984f9ff0f4da54a8.jpeg",
    "https://cdn.faire.com/fastly/bfc5f5a839162fe98b9413db2e0147864ee4d14b2a90b1f2243023212a444d38.jpeg",
    "https://cdn.faire.com/fastly/db4c30eb4670fa983c2cefff9b76742caa2cd18eb9c2e2743ce55b8940109d98.jpeg",
    "https://cdn.faire.com/fastly/12da6e2be773d107904e6848393f2b59461eae6c57592b5c1edc4c7d041a0fac.jpeg",
    "https://cdn.faire.com/fastly/0d25742aec7d3e49f6eff2bac253eb8ebeb9a92094a74ff5a8c6f088aa4b1f47.jpeg",
    "https://cdn.faire.com/fastly/bb2ced11885c510d3a7a146898e23b0b1efa4623fa46502a7a187cdf3cb04a3b.jpeg",
  ],
  priceDollars: 8.3,
  description:
    'This is perfect zodiac-themed accessory for fashionistas. Wear it on a daily basis when you want to show your zodiac sign and let the world know who you are, or on more formal occasions to add some sparkle to your look.They come with a luxurious wooden display for you to display them in a chic way. The wood display is not polished so if you want you can create your own presentation by painting or staining it.\n\nProduct Specifications: \n* Dimensions- Chain: 18" \n * Materials- Stainless Steel \n * Signature lobster clasp\n\n1 case includes 12 necklaces(with cards) \n\nPLEASE NOTE\nDepends on the availability, the cards may come with either craft or white paper.',
  tags: [],
  msrpDollars: 18,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:11.568Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
